import { TYPOGRAPHY } from './Typographys';
import { EMAIL_RULES, PASSWORD_RULES } from './validation';

export const RESET_PASSWORD_FORM_FIELDS = {
  EMAIL_FIELD: {
    formItemProps: {
      name: 'emailId',
      colon: false,
      rules: [...EMAIL_RULES],
    },
    inputProps: {
      label: 'Email address',
      type: 'email',
      placeholder: 'Enter your email address',
    },
  },
  CURRENT_PASSWORD_FIELD: {
    formItemProps: {
      name: 'currentPassword',
      colon: false,
      rules: [...PASSWORD_RULES],
    },
    inputProps: {
      label: 'Current password',
      type: 'password',
      placeholder: 'Enter your current password',
    },
  },
  NEW_PASSWORD_FIELD: {
    formItemProps: {
      name: 'newPassword',
      colon: false,
      rules: [...PASSWORD_RULES],
    },
    inputProps: {
      label: 'New password',
      type: 'password',
      placeholder: 'Enter your new password',
    },
  },
  CONFIRM_NEW_PASSWORD_FIELD: {
    formItemProps: {
      name: 'confirmNewPassword',
      colon: false,
      rules: [...PASSWORD_RULES],
    },
    inputProps: {
      label: 'Confirm new password',
      type: 'password',
      placeholder: 'Enter confirm new password',
    },
  },
};

export const RESET_PASSWORD_CONFIG = {
  HEADER: {
    text: 'Reset Password',
    type: TYPOGRAPHY.TITLE,
  },

  PARAGRAPH: {
    text: 'Kindly fill in your details below to update a new password',
    type: TYPOGRAPHY.PARA_BOLD,
  },
};

export const FORGOT_PASSWORD_POPUP_CONFIG = {
  POPUP_HEADING: {
    text: 'Password updated',
    type: TYPOGRAPHY.TITLE,
  },
  POPUP_BUTTON: {
    buttonProps: {
      htmlType: 'submit',
      type: 'primary',
      block: true,
    },
    text: 'Continue',
  },
};
export const RESET_PASSWORD_CTA = {
  RESET_BUTTON: {
    buttonProps: {
      htmlType: 'submit',
      type: 'primary',
      block: true,
    },
    text: 'Confirm',
  },
};
